import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { SubCategory } from '../types/sub-category.type';
import { ADMIN_SUB_CATEGORIES_API_PATHS } from '../constants/sub-categories-api-paths.constants';

type UseRestoreSubCategoryResult = {
  restoreSubCategory: (subCategoryId: string) => Promise<SubCategory | null>;
  isSubmitting: boolean;
};

export function useRestoreSubCategory(): UseRestoreSubCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreSubCategory = async (subCategoryId: string): Promise<SubCategory | null> => {
    setIsSubmitting(true);

    try {
      const restoredSubCategory = await HttpClient.post<SubCategory>(
        ADMIN_SUB_CATEGORIES_API_PATHS.RESTORE_SUB_CATEGORY(subCategoryId)
      );

      enqueueSnackbar('Sous-rubrique restaurée', { variant: 'success' });
      return restoredSubCategory;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la restauration de la sous-rubrique'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreSubCategory, isSubmitting };
}
